
const $ = require('jquery')
import Mixin from '../mixin'
const FeedbackForm =  require('./Feedback/FeedBackForm.vue')
import {mixins,Options} from "vue-property-decorator";

@Options({
  name: 'v-footer',
  components: {
    FeedbackForm
  }
})
export default class VFooter extends mixins(Mixin) {


  get currentYear() {
    return (new Date()).getFullYear()
  }
  mounted() {
    let footerContent = $('#footer .info-container li')
    toggleFooterContent()
    footerContent.click(function (e) {
      if (window.matchMedia('(max-width: 640px)').matches) {
        // don't slideUp when click <a>
        if (e.target.tagName === 'A') return
        footerContent.find('ul').slideUp(300)
        footerContent
          .find('.zmdi')
          .removeClass('zmdi-chevron-up')
          .addClass('zmdi-chevron-down')
        if (
          !$(e.currentTarget)
            .find('ul')
            .is(':visible')
        ) {
          $(e.currentTarget)
            .find('ul')
            .slideDown(300)
          $(e.currentTarget)
            .find('.zmdi')
            .removeClass('zmdi-chevron-down')
            .addClass('zmdi-chevron-up')
        }
      }
    })

    $(window).resize(function () {
      toggleFooterContent()
    })

    /**
     * show/hide footer content depend on max-width
     */
    function toggleFooterContent() {
      if (window.matchMedia('(max-width: 640px)').matches) {
        footerContent.find('ul').hide()
        footerContent
          .find('.zmdi')
          .removeClass('zmdi-chevron-up')
          .addClass('zmdi-chevron-down')
      } else {
        footerContent.find('ul').show()
      }
    }
  }

  showFeedbackModal() {
    (this.$refs.feedbackForm as InstanceType<typeof FeedbackForm>).showModal()
  }

}

// export default {
//   mixins: [Mixin],
//   components: {
//     FeedbackForm
//   },
//   computed: {
//     currentYear() {
//       return (new Date()).getFullYear()
//     }
//   },
//   mounted() {
//     let footerContent = $('#footer .info-container li')
//     toggleFooterContent()
//     footerContent.click(function (e) {
//       if (window.matchMedia('(max-width: 640px)').matches) {
//         // don't slideUp when click <a>
//         if (e.target.tagName === 'A') return
//
//         footerContent.find('ul').slideUp(300)
//         footerContent
//             .find('.zmdi')
//             .removeClass('zmdi-chevron-up')
//             .addClass('zmdi-chevron-down')
//         if (
//             !$(this)
//                 .find('ul')
//                 .is(':visible')
//         ) {
//           $(this)
//               .find('ul')
//               .slideDown(300)
//           $(this)
//               .find('.zmdi')
//               .removeClass('zmdi-chevron-down')
//               .addClass('zmdi-chevron-up')
//         }
//       }
//     })
//
//     $(window).resize(function () {
//       toggleFooterContent()
//     })
//
//     /**
//      * show/hide footer content depend on max-width
//      */
//     function toggleFooterContent() {
//       if (window.matchMedia('(max-width: 640px)').matches) {
//         footerContent.find('ul').hide()
//         footerContent
//             .find('.zmdi')
//             .removeClass('zmdi-chevron-up')
//             .addClass('zmdi-chevron-down')
//       } else {
//         footerContent.find('ul').show()
//       }
//     }
//   },
//   methods: {
//     showFeedbackModal() {
//       this.$refs.feedbackForm.showModal()
//     }
//   }
// }
